// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-right-template {\n  grid-template-columns: 50% 50%;\n  grid-template-areas: 'left right';\n}\n\n.top-bottom-template {\n  grid-template-rows: 50% 50%;\n  grid-template-areas: \n    'top top'\n    'bottom bottom';\n}\n\n.double-grid-template {\n  overflow-y: hidden;\n  grid-template-columns: 50% 50%\n}\n", ""]);
// Exports
module.exports = exports;
